// extracted by mini-css-extract-plugin
export var container = "_7s-0";
export var fallback = "_7s-5";
export var fallbackIcon = "_7s-6";
export var hidden = "_7s-2";
export var image = "_7s-3";
export var loaded = "_7s-4";
export var placeholder = "_7s-1";